<template>
  <div class="form-group" :class="'level-'+level" ><slot/></div>
</template>

<script>
export default {
  props: {
    level: {
      default: 1
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group {
  font-size: 18px;
  color: #444;
  font-weight: bold;
}
.level {
  &-1 {
     margin: 20px  10px;
  }
  &-2 {
    font-size: 14px;
     margin: 10px 0 10px -5px;
  }
}
</style>
